import * as React from 'react';
import styled from 'styled-components';
import { onlyPublic } from '../../utilities/only-public';
import { __ } from 'react-i18n';

import { Title } from 'eshop-defaults';
import { FormInputComponent } from 'eshop-defaults';
import { Loader } from 'eshop-defaults';
import { ButtonPrimary } from 'eshop-defaults';

import { ErrorAlert } from 'eshop-defaults';
import { SuccessAlert } from 'eshop-defaults';
import { AuthContainer } from '../../components/Auth/AuthComponent';
interface State {
  email: string;
  loading: boolean;
  sent: boolean;
  err: string;
}

interface Props {
  user: {
    id: number;
  };
  dispatch: any;
  API: any;
}

class LostPassword extends React.Component<Props, State> {
  state = {
    email: '',
    loading: false,
    sent: false,
    err: '',
  };

  onEmailChange = e => this.setState({ email: e.target.value });

  onClick = async e => {
    e.preventDefault();
    const { email } = this.state;
    if (!email.trim()) {
      return;
    }
    try {
      this.setState({ loading: true });
      await this.props.API.lostPassword(
        {},
        {
          email: this.state.email,
        },
      );
      this.setState({ loading: false, sent: true, err: '' });
    } catch (e) {
      let err;
      if (e.message === 'Conflict') {
        err = __('Obnovovací email na túto adresu už bol odoslaný');
      } else if (e.message === 'Not Found') {
        err = __('Táto adresa nie je registrovaná');
      } else {
        err = __('Nepodarilo sa odoslať obnovovací email');
      }
      this.setState({ loading: false, err });
    }
  };

  render() {
    return (
      <AuthContainer>
        <ContentWrapper>
          <Title>{__('Zabudnuté heslo')}</Title>

          {!this.state.sent ? (
            <form>
              <FormInputComponent
                type="email"
                placeholder={__('Zadajte email na obnovu hesla')}
                value={this.state.email}
                onChange={this.onEmailChange}
                disabled={this.state.loading}
              />
              <ButtonLabel>
                <ButtonPrimary click={this.onClick}>
                  {this.state.loading ? (
                    <Loader
                      loading={true}
                      style={{ transform: 'scale(0.3)' }}
                      primaryColor="rgba(163, 239, 243, 1)"
                      secondaryColor="rgba(163, 239, 243, 0.4)"
                    />
                  ) : (
                    __('Odoslať email')
                  )}
                </ButtonPrimary>
              </ButtonLabel>
            </form>
          ) : (
            <SuccessAlert
              style={{ width: '100%' }}
              message={`${__('Obnovovací email bol odoslaný na adresu')} ${
                this.state.email
              }`}
            />
          )}

          {this.state.err && (
            <ErrorAlert
              closeAlert={this.closeAlert}
              style={{ marginTop: '40px', width: '100%' }}
              message={this.state.err}
            />
          )}
        </ContentWrapper>
      </AuthContainer>
    );
  }

  private closeAlert = () => {
    this.setState({
      ...this.state,
      err: '',
    });
  };
}

export default onlyPublic(LostPassword);

const ContentWrapper = styled.div`
  width: 600px;

  @media only screen and (max-width: 800px) {
    width: 90%;
  }
`;

const ButtonLabel = styled.div`
  margin-top: 25px;
`;
